import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarFacturaPeriodo_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultarFacturaPeriodo",
    rutaEndPoint: "/EnterpriseServices/Brm/Factura/consultarFacturaPeriodo",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultarFacturaPeriodo_Entrada {
  Facturas_consultaFacturasPeriodo_Entrada: FacturasConsultaFacturasPeriodoEntrada;
}

export function builtConsultarFacturaPeriodo_Entrada(
  p_Facturas_consultaFacturasPeriodo_Entrada: FacturasConsultaFacturasPeriodoEntrada
) {
  var retorno: ConsultarFacturaPeriodo_Entrada = {
    Facturas_consultaFacturasPeriodo_Entrada:
      p_Facturas_consultaFacturasPeriodo_Entrada,
  };

  return retorno;
}

export interface FacturasConsultaFacturasPeriodoEntrada {
  CABECERA: CabeceraInput;
  NUMERO_CUENTA: string;
  FECHA_FIN: string;
  FECHA_INICIO: string;
}

export function builtFacturasConsultaFacturasPeriodoEntrada(
  P_CABECERA: CabeceraInput,
  P_NUMERO_CUENTA: string,
  P_FECHA_FIN: string,
  P_FECHA_INICIO: string
) {
  var retorno: FacturasConsultaFacturasPeriodoEntrada = {
    CABECERA: P_CABECERA,
    NUMERO_CUENTA: P_NUMERO_CUENTA,
    FECHA_FIN: P_FECHA_FIN,
    FECHA_INICIO: P_FECHA_INICIO,
  };

  return retorno;
}

export interface CabeceraInput {
  OPERACION: string;
  APLICATIVO: string;
  PARAMETRO: Parametro[];
}

export function builtCabecera(
  P_OPERACION: string,
  P_APLICATIVO: string,
  P_PARAMETRO: Parametro[]
) {
  var retorno: CabeceraInput = {
    OPERACION: P_OPERACION,
    APLICATIVO: P_APLICATIVO,
    PARAMETRO: P_PARAMETRO,
  };

  return retorno;
}

export interface Parametro {
  NOMBRE: string;
  VALOR: string;
}

export function builtParametro(P_NOMBRE: string, P_VALOR: string) {
  var retorno: Parametro = {
    NOMBRE: P_NOMBRE,
    VALOR: P_VALOR,
  };

  return retorno;
}

//SALIDA

export interface ConsultarFacturaPeriodo_Salida {
  Facturas_consultaFacturasPeriodo_Salida: FacturasConsultaFacturasPeriodoSalida;
}

export interface FacturasConsultaFacturasPeriodoSalida {
  CABECERA: Cabecera;
  RESULTADOS: Resultado[];
}

export interface Resultado {
  NUMERO_FACTURA: string;
  MONEDA: string;
  MONTO_FACTURADO: string;
  AJUSTES: string;
  CONSUMOS_DEL_MES: string;
  PAGOS_A_FACTURA: string;
  INICIO_PERIODO: string;
  FIN_PERIODO: string;
  FECHA_A_PAGAR: string;
  SALDO: string;
  SALDO_TOTAL: string;
  ESTATUS_FORMATO: string;
  FECHA_CIERRE: string;
  ID_FACTURA: string;
  FECHA_VENCIMIENTO: string;
  CONSECUTIVO: string;
}

export interface Cabecera {
  COD_ERROR: string;
  MSG_ERROR: string;
}


export type ConsultarFacturaPeriodo_Respuesta = ConsultarFacturaPeriodo_Salida;